import React from "react";
import Box from "@mui/material/Box";
import {
    chracterPosition,

} from "../../../../utils/index";
const colorCodesForAvatar = [
    "#405261", // A
    "#FF4D4F", // B
    "#FA541C", // C
    "#FA8C16", // D
    "#FAAD14", // E
    "#EB2F96", // F
    "#FADB14", // G
    "#A0D911", // H
    "#52C41A", // I
    "#5CDBD3", // J
    "#9254DE", // K
    "#F759AB", // L
    "#2F54EB", // M
    "#722ED1", // N
    "#1890FF", // O
    "#13C2C2", // P
    "#2DB7F5", // Q
    "#19BE6B", // R
    "#30A745", // S
    "#FA8C16", // T
    "#FAAD14", // U
    "#9254DE", // V
    "#F759AB", // W
    "#13C2C2", // X
    "#722ED1", // Y
    "#2DB7F5", // Z
];


const CommentItem = ({ commentItem, showBorder }) => {
    const avatarBgColor =
        colorCodesForAvatar[
        chracterPosition(commentItem.author?.substring(0, 1)?.toUpperCase())
        ];

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                paddingBottom: "30px",
                marginBottom: "30px",
                borderBottom: showBorder ? "1px solid #E5E9EC" : "none",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    marginBottom: "12px",
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <Box
                        sx={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            background: commentItem.avatar ? "#d1d5db" : avatarBgColor,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            flexShrink: 0,
                        }}
                    >
                        {commentItem.avatar ? (
                            <img
                                src={commentItem.avatar}
                                alt={commentItem.author}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "50%",
                                }}
                            />
                        ) : (
                            <span
                                style={{
                                    fontSize: "16px",
                                    color: "#fff",
                                    fontWeight: "bold",
                                }}
                            >
                                {commentItem.author
                                    ? commentItem.author.charAt(0).toUpperCase()
                                    : "V"}
                            </span>
                        )}
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Box
                            sx={{
                                color: "#061522",
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "18px",
                            }}
                        >
                            {commentItem.author}
                        </Box>
                        {commentItem.email && (
                            <Box
                                sx={{
                                    color: "#556575",
                                    fontFamily: "Inter",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "18px",
                                    marginTop: "2px",
                                }}
                            >
                                {commentItem.email}
                            </Box>
                        )}
                    </Box>
                </Box>

                <Box
                    sx={{
                        color: "#556575",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "18px",
                    }}
                >
                    {commentItem.date}
                </Box>
            </Box>

            <Box
                sx={{
                    color: "#405261",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "28px",
                    wordBreak: "break-word",
                    paddingLeft: "52px",
                }}
            >
                {commentItem.content}
            </Box>
        </Box>
    );
};

export default CommentItem;